var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-order-item",
    class: _vm.canGoDetail ? '.cursor-pointer' : '',
    on: {
      "click": _vm.navigate
    }
  }, [_vm.fieldSetting ? [_c('div', {
    staticClass: "s-order-item-info"
  }, [_vm.leftFieldSetting ? _c('div', {
    staticClass: "s-space-y-2 s-mr-auto"
  }, [_vm._l(_vm.leftFieldSetting, function (field) {
    return [_c('p', {
      key: field.key,
      staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
    }, [_vm._v(" " + _vm._s(field.value) + _vm._s(_vm.object[field.key]) + " ")])];
  })], 2) : _vm._e(), _vm.rightFieldSetting ? _c('div', {
    staticClass: "s-flex s-flex-col s-items-end"
  }, [_vm._l(_vm.rightFieldSetting, function (field) {
    return [_c('p', {
      key: field.key,
      staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
    }, [_vm._v(" " + _vm._s(field.value) + _vm._s(_vm.object[field.key]) + " ")])];
  })], 2) : _vm._e()])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }